class OpenSideMenuLink {
  constructor(options = {}) {
    this.element = options.element;
    this.menuId = this.element.dataset.openMenuId;

    this.sideNav = document.querySelector('#headerSideMenu .nav');
    this.openMenuButton = document.querySelector('.menu-label');
  }

  init() {
    this.bindClickEvent();
  }

  bindClickEvent() {
    this.element.addEventListener('click', (event) => {
      event.preventDefault();

      this.openSideMenu();
      this.openTargetMenu();
    });
  }

  openSideMenu() {
    if (this.sideNav) {
      if (this.openMenuButton) {
        this.openMenuButton.click();
      }
    }
  }

  openTargetMenu() {
    // eslint-disable-next-line no-restricted-globals
    const targetButton = document.querySelector(
      `#headerSideMenu #${CSS.escape(this.menuId)}`,
    );

    if (targetButton) {
      targetButton.click();
    }
  }
}

export default OpenSideMenuLink;
